export const testimonials = [
  {
    id: 1,
    name: '王小明',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20photo%2C%20warm%20friendly%20smile%2C%20clean%20white%20background%2C%20natural%20lighting%2C%20business%20casual%20style%2C%20headshot%20photography&width=100&height=100&seq=avatar-01&orientation=squarish',
    rating: 5,
    content: '西瓜影视的画质真的太棒了！蓝光超清完全不卡顿，我家里100M宽带看着特别流畅。片源更新也很快，新片基本第一时间就能看到。强烈推荐！',
    date: '2026-07-20',
  },
  {
    id: 2,
    name: '李雪儿',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20photo%2C%20gentle%20smile%2C%20clean%20white%20background%2C%20soft%20natural%20lighting%2C%20casual%20elegant%20style%2C%20headshot%20photography&width=100&height=100&seq=avatar-02&orientation=squarish',
    rating: 5,
    content: '作为追剧党，西瓜影视简直就是我的宝藏！分类特别清楚，想找什么剧一搜就有。而且没有任何广告弹窗，观影体验一级棒。',
    date: '2026-07-18',
  },
  {
    id: 3,
    name: '张伟',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20photo%2C%20confident%20expression%2C%20clean%20white%20background%2C%20studio%20lighting%2C%20modern%20casual%20style%2C%20headshot%20photography&width=100&height=100&seq=avatar-03&orientation=squarish',
    rating: 5,
    content: '用了大半年的西瓜影视，从没遇到过缓冲问题。高清画质看动作片和科幻片简直不要太爽，细节都能看得清清楚楚。朋友都被我安利过来了。',
    date: '2026-07-15',
  },
  {
    id: 4,
    name: '赵雨涵',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20female%20portrait%20photo%2C%20bright%20smile%2C%20clean%20white%20background%2C%20fresh%20natural%20lighting%2C%20youthful%20casual%20style%2C%20headshot%20photography&width=100&height=100&seq=avatar-04&orientation=squarish',
    rating: 5,
    content: '最喜欢西瓜影视的分类功能，按类型、年份、评分都能筛选。动漫资源也特别全，孩子放假在家看动画片很方便，家长控制功能也很贴心。',
    date: '2026-07-12',
  },
  {
    id: 5,
    name: '陈志远',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20male%20portrait%20photo%2C%20calm%20expression%2C%20clean%20white%20background%2C%20professional%20studio%20lighting%2C%20business%20style%2C%20headshot%20photography&width=100&height=100&seq=avatar-05&orientation=squarish',
    rating: 4,
    content: '整体体验很不错，片源丰富度超出预期。偶尔周末高峰时段加载会慢一点点，但总体瑕不掩瑜。希望继续保持这个水准！',
    date: '2026-07-10',
  },
];

export const stats = [
  { label: '影视资源', value: '50,000+', icon: 'ri-film-line' },
  { label: '日均更新', value: '200+', icon: 'ri-refresh-line' },
  { label: '活跃用户', value: '800万+', icon: 'ri-user-heart-line' },
  { label: '好评率', value: '98.6%', icon: 'ri-thumb-up-line' },
];

export const faqs = [
  {
    question: '西瓜影视是否需要注册才能观看？',
    answer: '不需要。西瓜影视完全免费开放，无需注册或登录即可直接观看所有影片内容，我们致力于为用户提供最便捷的观影体验。',
  },
  {
    question: '支持哪些设备观看？',
    answer: '西瓜影视支持电脑、平板、手机等多种设备在线观看。我们的网站采用响应式设计，在任何屏幕尺寸下都能获得良好的观影体验。',
  },
  {
    question: '视频画质如何？会不会卡顿？',
    answer: '我们提供最高蓝光超清画质，采用先进的视频压缩和CDN加速技术，确保流畅不缓冲的播放体验。具体画质取决于您的网络带宽和设备性能。',
  },
  {
    question: '影片更新频率是怎样的？',
    answer: '我们每天更新200+部影视内容，热门新片上映后会在第一时间上线。电视剧和综艺节目会在播出后24小时内更新最新集数。',
  },
  {
    question: '遇到播放问题该如何处理？',
    answer: '如遇到播放问题，建议先尝试刷新页面或切换网络。如果问题持续存在，可以通过"联系我们"页面提交反馈，我们的技术团队会在24小时内处理。',
  },
];